<template>
    <div class="breakdown-section">
        <div class="graph-wrapper">
            <Graph
                :labels="labels"
                :colors="colors"
                :revenues="revenues" />
        </div>
        <div class="revenue-breakdown-labels">
            <template v-for="(label, index) in labels">
                <div class="box" :style="{'background-color': colors[index]}"></div>
                <label>{{ label }}</label>
                <span class="percent">{{ revenuePercentOf(revenues[index]) }}%</span>
                <span class="last">{{ revenues[index] | currency }}</span>
            </template>
        </div>
    </div>
</template>

<script>
import Graph from './BreakdownGraph'

export default {
    name: 'DetailsRevenueBreakdown',
    components: {
        Graph,
    },
    props: {
        listing: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        fields: [
            'revenue_fees_recurring',
            'revenue_trails_recurring',
            'revenue_12b1s_recurring',
            'revenue_renewals_recurring',
            'revenue_hourly_recurring',
            'revenue_hourly_transactional',
            'revenue_financial_planning_recurring',
            'revenue_financial_planning_transactional',
            'revenue_other_recurring',
            'revenue_other_transactional',
            'revenue_osj_recurring',
            'revenue_osj_transactional',
            'revenue_accounting_recurring',
            'revenue_accounting_transactional',
            'revenue_direct_insurance_recurring',
            'revenue_direct_insurance_transactional',
            'revenue_group_health_insurance_recurring',
            'revenue_group_health_insurance_transactional',
            'revenue_medicare_recurring',
            'revenue_medicare_transactional',
            'revenue_securities_commissions_transactional',
            'revenue_insurance_commissions_transactional',
            'revenue_trails_commissions_transactional',
            'revenue_12b1s_commissions_transactional',
            'revenue_mutual_fund_commissions_transactional',
            'revenue_stock_commissions_transactional',
            'revenue_retirement_plans_recurring',
            'revenue_compilations',
        ],

        fieldColors: [
            '#0096A6',
            '#97C131',
            '#D25642',
            '#5F6062',
            '#C90838',
            '#CCEAED',
            '#FFC000',
            '#7030A0',
            '#00B0F0',
            '#ED7D31',
            '#97C131',
            '#F1563F',
            '#0096A6',
            '#5F6062',
            '#CCEAED',
            '#131906',
            '#0096A6', // '#E6E7E8',
            '#4D28C7',
            '#DB6820',
            '#97C131',
            '#F1563F',
            '#C90838',
            '#5F6062',
            '#CCEAED',
            '#131906',
            '#04DDDD',
            '#4D28C7',
            '#DB6820',
        ],

        fieldLabels: [
            'Fees',
            'Trails',
            '12b-1s',
            'Renewals (Insurance)',
            'Hourly (Recurring)',
            'Hourly (Transactional)',
            'Financial Planning Fees (Recurring)',
            'Financial Planning Fees (Transactional)',
            'Other (Recurring)',
            'Other (Transactional)',
            'OSJ / Overrides (Recurring)',
            'OSJ / Overrides (Transactional)',
            'Accounting / Taxes (Recurring)',
            'Accounting / Taxes (Transactional)',
            'Direct Insurance (Recurring)',
            'Direct Insurance (Transactional)',
            'Group Health Insurance (Recurring)',
            'Group Health Insurance (Transactional)',
            'Medicare (Recurring)',
            'Medicare (Transactional)',
            'Securities Commissions (Transactional)',
            'Insurance Commissions (Transactional)',
            'VA Commissions',
            'MF Commissions',
            'Mutual Fund Commissions',
            'Stock Commissions',
            'Retirement Plans',
            'Compilations'
        ],
    }),

    computed: {
        colors () {
            return this.fieldColors
                .filter((_, i) => {
                    return Number(this.listing[this.fields[i]]) > 0
                })
        },

        labels () {
            let arrObj = [];

            // create arr of objs [ { field_label: value } ]
            this.fields.map((field, i) => {
                arrObj.push({ [this.fieldLabels[i]]: this.listing[field]});
            });

            // sort by values - large to small
            // arrObj = arrObj
            //     .sort((a, b) => {
            //         return Object.values(b)[0] - Object.values(a)[0];
            //     });

            // const arr = arrObj.map( (a) => {
            //     Object.keys(a)[0] 
            // });

            arrObj = arrObj.filter((_, i) => {
                return Number(this.listing[this.fields[i]]) > 0
            });

            // sort by values - large to small
            arrObj.sort((a, b) => {
                return Object.values(b)[0] - Object.values(a)[0];
            });
            
            // pull out first 10
            arrObj.slice(0, 10);

            const use_lables = arrObj.map( (a) => {
                return Object.keys(a)[0]
            });

            return use_lables
        },

        revenues () {
            let arrObj = [];

            // create arr of objs [ { field_label: value } ]
            this.fields.map((field) => {
                arrObj.push({ [field]: this.listing[field]});
            });

            // sort by values - large to small
            arrObj = arrObj
                .sort((a, b) => {
                    return Object.values(b)[0] - Object.values(a)[0];
                });
            // console.log(arrObj)

            // pull out first 10
            arrObj = arrObj.slice(0, 10);

            const arr = arrObj.map((a) => {
                return Object.values(a)[0];
            })

            // filter out any with value = 0
            return arr
                .map(item => Number(item) || 0)
                .filter(item => item > 0)
        },

        totalRevenue () {
            return this.revenues.reduce((sum, item) => sum + item, 0)
        }
    },

    methods: {
        revenuePercentOf (revenue) {
            // return Math.round(revenue * 100 / this.totalRevenue)
            return ((revenue / this.totalRevenue) * 100).toFixed(2)
        }
    }
}
</script>

<style scoped>
    .breakdown-section {
        display: grid;
        grid-template-columns: auto 450px;
        grid-template-rows: 300px;
        justify-content: space-around;
        background-color: #EFEFEF;
    }

    .info-item-group {
        margin: auto;
        padding: 40px;

        grid-template-columns: auto !important;
        align-items: center !important;
        justify-content: center !important;

        background-color: #F2F2F2 !important;
        border-radius: 4px;

        text-align: center;
    }

    .info-item-group span {
        font-family: "SansationBold", sans-serif !important;
        font-size: 20px !important;
    }

    .info-item-group img {
        margin: 0 auto;
    }

    .graph-wrapper,
    .graph-wrapper >>> div {
        height: 100%;
    }

    .revenue-breakdown-labels {
        display: inline-grid;
        grid-column-gap: .6em;
        grid-row-gap: 1.5em;
        grid-template-columns: auto auto auto auto;
        padding-left: .07em;
        align-content: center;
    }

    .revenue-breakdown-labels label {
        font-family: "Sansation Bold", sans-serif;
        font-size: 14px;
        text-align: left;
    }
    .revenue-breakdown-labels span.percent {
        font-size: 14px;
        text-align: right;
    }
    .revenue-breakdown-labels span.last {
        font-size: 14px;
        text-align: right;
    }

    .box {
        width: 15px;
        height: 15px;
        margin-top: 4px;
    }
    .testing-border {
        border: 1px solid black;
    }
</style>


// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/section-revenue/RevenueBreakdown.vue